import React from 'react';
import moment from 'moment';
import { compact, isEmpty } from 'lodash';
import { LEARN_TYPES } from 'constants/config';
import DateFormat from 'constants/date_format';
import withComputedProps from './withComputedProps';

const formatDate = date => moment(date).format(DateFormat.MONTH_DAY_SHORT);

const Status = ({ type, progress, isIncomplete, isCompleted, hasScore }) => {
  const children = compact([
    type === LEARN_TYPES.LESSON && isIncomplete && (
      <span key="startDate">
        {t('progress.started')} {formatDate(progress.startDate)}
      </span>
    ),
    isCompleted && hasScore && (
      <span key="score">
        Score:
        <span className="ml-4 c-green">{progress.score}%</span>
      </span>
    ),
  ]);
  return (
    !isEmpty(children) && (
      <div className="LearnContentCardStatus">{children}</div>
    )
  );
};

export default withComputedProps(Status);
